import { Outlet } from "react-router-dom"
import React from "react"

const Root = () => {
  return <Outlet />
}

export default Root
